module.exports = __webpack_public_path__ + "img/ic-smartplug-hover.fcab6bb4.svg";